// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"noMatch__wrapper--3g4TC","text":"noMatch__text--3JsR3"};